import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import { getApi } from '../../../api';

const PopupBooking = ({ message, setToggleConfirmBooking, setToggleAcceptBooking }) => {
  const [open, setOpen] = React.useState(true);

  const handleConfirmBooking = async () => {
    let booking = message.booking;
    booking.restrictions.allow_conflicts = true;
    console.log('TCL: handleConfirmBooking -> booking', booking);

    const response = await getApi().put(`/users/${booking.user.id}/bookings/${booking.id}`, {
      ...booking,
    });

    if (response.status === 200) {
      setToggleAcceptBooking(true);
      setToggleConfirmBooking(false);
    }
  };

  const handleClose = () => {
    setToggleConfirmBooking(false);
  };
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{'Confirmación de aprobación'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {'Conflictos encontrados:'}
            <br />
            <ul>
              {message.driverMessage && (
                <li style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                  {'El vehiculo seleccionado esta asignado a otra solicitud a la misma hora.'}
                </li>
              )}
              {message.vehicleMessage && (
                <li style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                  {'El chofer seleccionado esta asignado a otra solicitud a la misma hora.'}
                </li>
              )}
            </ul>
            {'¿Desea hacer esta asignación aunque hayan conflictos?'}
            <br />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmBooking} color="primary">
            Confirmar
          </Button>
          <Button onClick={handleClose} color="primary" autoFocus>
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default PopupBooking;
